module.exports = "//public.getcloudapp.com/packs/media/images/pro@2x-a6a0193a19706c47c1c2e9250e73215e.png";